import { WebserviceProjectResponse } from '@yandex-int/k-common/client/api/defs/get-webservice-project';
import { INode } from 'react-accessible-treeview';
import slugify from 'slugify';

interface ITreeNode {
    name: string;
    children?: ITreeNode[];
}

export const getTree = (files: string[]) => {
    const tree: ITreeNode = {
        name: '',
    };
    for (const file of files) {
        const parts = file.split('/');
        let node = tree;
        for (const part of parts) {
            if (!node.children) {
                node.children = [];
            }
            let child = node.children.find((c) => c.name === part);
            if (!child) {
                child = { name: part };
                node.children.push(child);
            }
            node = child;
        }
    }
    return tree;
};

export function* getParentIds(data: INode[], id: number): Generator<number> {
    while (id) {
        yield id;
        id = data[id].parent || 0;
    }
}

export const getPathToNode = (data: INode[], id: number) => {
    return [...getParentIds(data, id)]
        .map((pid) => data[pid].name)
        .reverse()
        .join('/');
};

export const getImageName = (file: File, existingImages: WebserviceProjectResponse['images']) => {
    const fileNameParts = file.name.split('.');
    const extension = fileNameParts.pop();
    const fileNameWithoutExtension = fileNameParts.join('.');
    const fileNameSlug = slugify(fileNameWithoutExtension, {
        lower: true,
        strict: true,
        locale: 'ru',
        trim: true,
        replacement: '-',
    });
    let duplicateNumber = 1;
    const getDuplicateName = () => {
        const suffix = duplicateNumber > 1 ? `-${duplicateNumber}` : '';
        return `${fileNameSlug}${suffix}.${extension}`;
    };
    while (existingImages.find((i) => i.name === getDuplicateName())) {
        duplicateNumber += 1;
    }
    return getDuplicateName();
};
